export enum EngMaintenanceReservoir {
  SLIDER = 'INGENIERIA_MANTENIMIENTO_Slider',
  BIBLIOTECA_GENERAL = 'INGENIERIA_MANTENIMIENTO_BIBLIOTECA',
  COMMENTS_SUGGESTIONS = 'INGENIERIA_MANTENIMIENTO_ACCESOS_INTERES',

  COMMUNICATIONS_NEWS_CATEGORIAS = 'INGENIERIA_MANTENIMIENTO_COMUNICADOS_CATEGORIA',
  COMMUNICATIONS_NEWS_SUBCATEGORIA = 'INGENIERIA_MANTENIMIENTO_COMUNICACIONES_SUBCATEGORIA',
  COMMUNICATIONS_NEWS_ITEM = 'INGENIERIA_MANTENIMIENTO_COMUNICACIONES',

  DOC_LEGALES_CATEGORIAS = 'INGENIERIA_MANTENIMIENTO_DOCUMENTACION_LEGAL_CATEGORIA',
  DOC_LEGALES_SUBCATEGORIA = 'INGENIERIA_MANTENIMIENTO_DOCUMENTACION_LEGAL_SUBCATEGORIA',
  DOC_LEGALES_ITEM = 'INGENIERIA_MANTENIMIENTO_DOCUMENTACION_LEGAL',

  CAP_GOOD_PRACTICES_CATEGORIAS = 'INGENIERIA_MANTENIMIENTO_CAPACITACIONES_CATEGORIA',
  CAP_GOOD_PRACTICES_SUBCATEGORIA = 'INGENIERIA_MANTENIMIENTO_CAPACITACIONES_SUBCATEGORIA',
  CAP_GOOD_PRACTICES_ITEM = 'INGENIERIA_MANTENIMIENTO_CAPACITACIONES',

  PREVENTIVE_MANT_CATEGORIAS = 'INGENIERIA_MANTENIMIENTO_PREVENTIVO_CATEGORIA',
  PREVENTIVE_MANT_SUBCATEGORIA = 'INGENIERIA_MANTENIMIENTO_PREVENTIVO_SUBCATEGORIA',
  PREVENTIVE_MANT_ITEM = 'INGENIERIA_MANTENIMIENTO_PREVENTIVO',

  PROCEDURES_CATEGORIAS = 'INGENIERIA_MANTENIMIENTO_PROCEDIMIENTOS_CATEGORIA',
  PROCEDURES_ITEM = 'INGENIERIA_MANTENIMIENTO_PROCEDIMIENTOS',
}
